export abstract class ToStringAbstract {
    /** * 字符化 */
    public abstract toString(): string
}